import { useState } from "react";

import { useApi, ApiError } from "../api/client";
import "./SignoffEmailTest.css";

/**
 * Super-admin email test: send yourself a sample supervisor sign-off email to
 * verify Graph Mail.Send is configured and see how it renders before go-live.
 * It goes to your own mailbox (from your sign-in) — no input needed. The email
 * is the identical template a real assessment produces, with the Approve /
 * Return buttons. English-only for now, matching the SMS test (i18n follow-up).
 */
export function SignoffEmailTest() {
  const callApi = useApi();
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; message: string } | null>(
    null,
  );

  async function send() {
    if (sending) return;
    setSending(true);
    setResult(null);
    try {
      await callApi<{ ok: boolean }>(`/admin/signoff-email-test`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: "{}",
      });
      setResult({
        ok: true,
        message: "Sent — check your inbox for the sample sign-off email.",
      });
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.status === 403
            ? "Super admins only."
            : err.status === 400
              ? "Your account has no mailbox to send to."
              : "Send failed — check WFP_NOTIFICATION_SENDER and the Mail.Send permission."
          : "Send failed — please try again.";
      setResult({ ok: false, message });
    } finally {
      setSending(false);
    }
  }

  return (
    <section className="emailtest">
      <h2 className="emailtest__title">
        Send a test sign-off email (super admin)
      </h2>
      <p className="emailtest__note">
        Emails <strong>you</strong> a sample supervisor sign-off email — the
        same template kaimahi assessments produce, with the Approve / Return
        buttons. Verifies Graph delivery and layout. No whānau data.
      </p>
      <button
        type="button"
        className="emailtest__btn"
        disabled={sending}
        onClick={() => void send()}
      >
        {sending ? "Sending…" : "Send test email"}
      </button>
      {result && (
        <p
          className={result.ok ? "emailtest__ok" : "emailtest__err"}
          role="status"
        >
          {result.message}
        </p>
      )}
    </section>
  );
}

export default SignoffEmailTest;
